export default {"src":"/_next/static/image/public/images/flags/flag_1345.66cd965a8917a3c88f424042de1fa8c5.svg","height":16,"width":24};